import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

export const getAvatarIsLoading = (state: State) => state.avatarIsLoading;
export const getMimeType = (state: State) => state.mimeType;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getAvatarIsLoading,
  getMimeType,
};
